import { baseApi } from './base.api';

export const devApi = {
  ...baseApi,
  baseUrl: 'https://api.dev.jive.com',
  notificationUrl: 'https://webrtc.dev.jive.com/notification-channel-anonymous/v1/channels',
};
